import { useLocale, useTranslations } from 'next-intl'

import { TRefundStatus } from '@/entities/contract'
import { cn } from '@/shared/lib'
import { Stepper } from '@/shared/ui'

import {
  useStepLabel,
  getCurrentStep,
  Props as GetStepLabelProps,
} from './step'

export type Props = Omit<GetStepLabelProps, 'currentStep'> & {
  refundStatus: TRefundStatus | null
}

export const StatusStepper = (props: Props) => {
  const t = useTranslations('lease_detail.lease_status')
  const locale = useLocale()
  const isEnglish = locale === 'en'

  const { contractStatus, refundStatus, ...restProps } = props

  const currentStep = getCurrentStep(contractStatus, refundStatus)

  const step = useStepLabel({ currentStep, contractStatus, ...restProps })

  return (
    <Stepper.Root activeStep={currentStep}>
      {step.map((step, index) => (
        <Stepper.Step key={index}>
          <Stepper.Label className="flex items-center gap-4">
            <span className={cn('w-[76px]', isEnglish && 'w-[150px]')}>
              {step.label}
            </span>
            {step.time && (
              <span className="typo-label2 font-normal text-gray-500">
                {t('datetime', { datetime: step.time })}
              </span>
            )}
          </Stepper.Label>
        </Stepper.Step>
      ))}
    </Stepper.Root>
  )
}
